// src/pages/feed/FeedPage.tsx
import React from "react";
import SocialLayout from "./SocialLayout";
import Feed from "./components/feed";

const FeedPage: React.FC = () => {
  return (
    <SocialLayout title="Rede Social">
      <h1 className="h4 fw-bold mb-4">Feed</h1>
      <Feed />
    </SocialLayout>
  );
};

export default FeedPage;
